export default {
	de: {
		// general
		yes: 'Ja',
		no: 'Nein',
		emptyTableColumn: '-',
		continue: 'Weiter',
		previous: 'Zurück',
		added: 'Hinzugefügt',

		dateFormat: {
			short: 'DD.MM.YYYY'
		},

		// navigation terms
		products: 'Produkte',
		watchlists: 'Merklisten',
		authenticateWithZoho: 'Mit Zoho authentifizieren',

		// woodtypes
		product: 'Produkt',
		veneer: 'Furnier',
		pallet: 'Palette',

		// search types
		searchTypes: {
			blockSearch: 'Stämme',
			palletSearch: 'Paletten'
		},

		// product types
		veneerLog: 'Furnierblock',

		// gallery
		speciesCount: '{count} Holzarten',
		viewType: 'Ansicht',
		searchType: 'Ebene',
		filter: 'Filter',

		// product card
		name: 'Name',
		species: 'Holzart',
		logNo: 'Block-Nr.',
		logArea: 'Menge',
		packageArea: 'Pakete',
		inLogPercentage: 'in Block',
		measuredArea: 'abg.',
		palletArea: 'Pal.',
		inPalletPercentage: 'in Pal.',
		resultArea: 'Menge',
		quality: 'Qualität',
		grade: 'Taxe',
		place: 'Platz',
		thickness: 'Stärke',
		maxLength: 'Max. Länge',
		structure: 'Struktur',
		characteristic: 'Eigenschaft',
		palletNo: 'Paletten-Nr.',
		internalQuality: 'Interne Qualität',
		palletInfo: 'Paletteninfo',
		palletInfoInternal: 'Interne Paletteninfo',
		logInfo: 'Blockinfo',
		furtherInformation: 'Weitere Angaben',
		logUnavailable: {
			short: 'Stamm nicht verfügbar',
			long: 'Dieser Stamm ist leider nicht mehr verfügbar.'
		},
		palletUnavailable: {
			short: 'Pallette nicht verfügbar',
			long: 'Diese Pallette ist leider nicht mehr verfügbar.'
		},
		bundleCount: 'Pakete',
		previewImageUnavailable: 'Das Vorschaubild ist leider nicht verfügbar',

		// watchlist
		customer: 'Kunde',
		contact: 'Kontakt',
		shared: 'Freigegeben',
		currency: 'Währung',
		settingsTab: 'Einstellungen',
		searchParamsTab: 'Suchparameter',
		dynamic: 'Dynamisch',
		static: 'Statisch',
		watchLog: 'Furnierblock merken',
		watchPallet: 'Palette merken',

		// system text
		noResults: 'Keine Ergebnisse',
		noSearchParams: 'Bitte Suchparameter angeben',
		addDescription: 'Beschreibung hinzufügen...',
		addPrice: 'Preis hinzufügen...',
		more: 'mehr',
		less: 'weniger',
		confirmationText: {
			deleteWatchlist: 'Möchten Sie die Merkliste "{watchlistName}" wirklich löschen?',
			deleteWatchlistItem: 'Möchten Sie dieses Objekt von der Merkliste entfernen?',
			removeLogFromVirtual: 'Möchten Sie diesen Stamm entfernen? Dabei werden auch alle diesem Stamm zugehörigen Pakete und Bilder entfernt.',
		},
		watchlistUnavailable: 'Diese Merkliste ist nicht verfügbar.',

		// veneer search sorting
		sorting: 'Sortieren nach',

		log: {
			selectedPreviewImage: 'Gewähltes Vorschaubild'
		},

		bundle: {
			packageNr: 'PaketNr.',
			sheets: 'Blattzahl',
			length: 'Länge',
			width: 'Breite',
			area: 'Fläche',
			originalLog: 'Original-Stamm-Nr.',
			originalBundleNo: 'Original-Paket-Nr.'
		},

		virtual: {
			title: 'Virtueller Stamm',
			bundleTab: 'Stämme',
			imageTab: 'Bilder',
			infoTab: 'Stammdaten',
			noBundles: 'Keine Pakete verfügbar',
			virtualBlock: 'Virtueller Block',
			removeLog: 'Stamm entfernen',
			addAllBundles: 'Alle Pakete hinzufügen',
		},

		label: {
			search: 'Suchen',

			crdate: 'Erstelldatum',

			// gallery
			color: 'Farbe',
			application: 'Anwendung',
			occurrence: 'Vorkommen',
			availability: 'Verfügbarkeit',
			pricegroup: 'Preisgruppe',
			fsc: 'Nur FSC® zertifizierte',
			pefc: 'Nur PEFC zertifizierte',

			// searchbar
			from: 'von',
			to: 'bis',
			thickness: 'Furnierstärke in mm',
			characteristic: 'Eigenschaft',
			qualities: 'Qualität',
			structure: 'Struktur',
			length: 'Länge',
			width: 'Breite',
			grade: 'Taxe',
			internalQuality: 'Interne Qualität',
			logNo: 'Blocknummer',
			palletNo: 'Paletten-Nr.',
			info: 'Info',
			place: 'Platz',

			// watchlist
			watchlist: 'Merkliste',
			watchlistName: 'Name',
			price: 'Preis',
			comment: 'Kommentar',
			seller: 'Verkäufer',
			type: 'Typ',
			language: 'Sprache',
			itemCount: 'Stämme',

			simplified: 'Einfache Merklistenansicht',
			showBundleImages: 'Maschinenbilder anzeigen',
			shared: 'Freigegeben',
			sharedUntil: 'Freigegeben bis',
			toggleAllLogImages: 'Alle ab-/anwählen',

			languages: {
				German: 'Deutsch',
				English: 'Englisch'
			},

			productTypes: {
				0: 'Furnier'
			},
			watchlistType: 'Typ'
		},

		unit: {
			mm: 'mm',
			cm: 'cm',
			m: 'm',
			sqm: 'm²',
			pricePerSqm: '€/m²',
			perSqm: '/m²',
			percentage: '%'
		},

		input: {
			//all: 'Alle',
			allColors: 'Alle Farben',
			allApplications: 'Alle Anwendungen',
			allOccurrences: 'Alle Vorkommen'
		},

		// buttons
		button: {
			logout: 'Abmelden',
			back: 'Zurück',
			watch: 'Merken',
			save: 'Speichern',
			create: 'Erstellen',
			remove: 'Entfernen',
			update: 'Übernehmen',
			delete: 'Löschen',
			edit: 'Bearbeiten',
			cancel: 'Abbrechen',
			search: 'Suchen',
			preview: 'Vorschau',
			watchlistSettings: 'Merklisten Einstellungen',
			share: 'Freigabe Einstellungen',
			newVirtualLog: 'Virtuellen Stamm erstellen',
			addToVirtualLog: 'Zu virtuellen Stamm hinzufügen',
			addToWatchlist: 'Zu Merkliste hinzufügen',
			addAllToWatchlist: 'Alle zur Merkliste hinzufügen',
			createWatchlist: 'Neue Merkliste',
			deleteWatchlist: 'Merkliste löschen',
			editSearchParams: 'Suchparameter bearbeiten',
			copyWatchlistLink: 'Freigabelink',
			copyNeutralWatchlistLink: 'Neutraler Link',
			newWatchlistAddFromWatchlist: 'Blöcke über Merklisten hinzufügen',
			newWatchlistAddFromSearch: 'Blöcke über Produktsuche hinzufügen',
			newWatchlistSearchParametersFromSearch: 'Parameter über Produktsuche hinzufügen',
			newWatchlistSearchParametersFromWatchlist: 'Parameter über Merkliste hinzufügen',
			addLogsToVirtualFromSearch: 'Blöcke über die Produktsuche hinzufügen',
			addLogsToVirtualFromWatchlist: 'Blöcke über Merklisten hinzufügen',
			download: 'Herunterladen',
			gallery: 'Galerie',
			list: 'Liste',
			listtype: {
				1: 'Name',
				name: 'Name',
				2: 'H. Name',
				tradename: 'Handelsname',
				3: 'Bot. Name',
				botanicalname: 'Botanischer Name'
			},
			measurementList: 'Maßliste',
			downloadImages: 'Bilder herunterladen',
			confirmSettings: 'Einstellungen übernehmen',
			downloadWatchlistSummary: 'Merkliste exportieren',
			previousLog: 'Vorheriger Stamm',
			nextLog: 'Nächster Stamm',
			logSearchSorting: {
				0: 'Block-Nr.',
				1: 'Paletten-Nr.',
				2: 'Int. Qualität',
				3: 'Qualität',
				4: 'Platz'
			},
			watchlistSorting: {
				added: 'Hinzugefügt',
				logArea: 'Menge',
				customerQualityName: 'Qualität',
				logNo: 'Block-Nr.',
				palletNo: 'Paletten-Nr.'
			},
			minimize: 'Minimieren',
			palletLogs: 'Stammliste',
			addAllPalletLogsToWatchlist: 'Alle Blöcke zu Merkliste hinzufügen',
			detailView: 'Detailansicht'
		},

		addToWatchlist: {
			step: {
				1: 'Merkliste wählen',
				2: 'Blockdaten bearbeiten',
				3: 'Bilder auswählen'
			}
		},
		activeWatchlistsTableTitle: 'Bereits auf folgenden Merklisten',
		checkingActiveWatchlists: 'Suche nach Verwendungen',

		tooltip: {
			remove: 'Entfernen',
			asPreviewImage: 'Als Vorschaubild nutzen',
			resetPreviewImage: 'Original-Vorschaubild wiederherstellen',
			setWatchlistItemLogImages: 'Handbilder',
			createWatchlistFromSearchParams: 'Dynamische Merkliste aus aktueller Suche erstellen.',
			resetSearchParams: 'Suche zurücksetzen'
		},

		// snackbar messages
		snack: {
			// generic request error
			requestError: 'Fehler bei der Datenübertragung.',
			// system errors
			noLogin: 'Sie wurden aufgrund von Inaktivität automatisch ausgeloggt.',
			zohoAuthenticationError: 'Fehler bei der Authentifizierung mit Zoho, bitte überprüfen Sie Ihren Loginstatus.',
			// confirmations
			addedToWatchlist: 'Objekt wurde der Merkliste hinzugefügt.',
			alreadyOnWatchlist: 'Objekt befindet sich bereits auf dieser Merkliste.',
			alreadyOnVirtualLogInWatchlist: 'Objekt befindet sich bereits in einem virtuellen Stamm auf dieser Merkliste.',
			addedToVirtualLogOnWatchlist: 'Objekt wurde einem virtuellen Stamm auf der Merkliste hinzugefügt.',
			createdAndAddedToVirtualLogOnWatchlist: 'Virtueller Stamm auf der Merkliste erstellt und Objekt hinzugefügt.',
			matchingLogOnWatchlist: 'Passender Stamm auf Merkliste gefunden. Dieses Objekt wird zu einem virtuellen Stamm hinzugefügt.',
			createdWatchlist: 'Neue Merkliste wurde erfolgreich angelegt.',
			deletedWatchlist: 'Merkliste wurde gelöscht.',
			updatedWatchlist: 'Einstellungen erfolgreich aktualisiert.',
			updatedWatchlistItem: 'Einstellungen erfolgreich aktualisiert.',
			watchlistLinkSuccessfullyCopied: 'Der Freigabelink wurde in die Zwischenablage kopiert.',
			watchlistLinkCopyError: 'Der Freigabelink konnte nicht kopiert werden.',
			updatedVirtualLog: 'Virtueller Stamm aktualisiert.',
			addedToVirtualLog: 'Zu virtuellem Stamm hinzugefügt.',
			alreadyOnVirtualLog: 'Stamm bereits hinzugefügt.'
		},

		error: {
			customer: 'Bitte wählen Sie einen Kunden aus.',
			logProps: {
				species: 'Bitte wählen Sie eine Holzart aus.',
				name: 'Bitte geben Sie eine Block-Nr. an.'
			},
			watchlistProps: {
				name: 'Bitte geben Sie einen Namen für diese Merkliste an.'
			}
		},

		mask: {
			currency: '#,##'
		},

		languageSwitcher: {
			german: 'Deutsch',
			english: 'English',
			simple: {
				german: 'DE',
				english: 'EN'
			}
		}
	},
	en: {
		// general
		yes: 'Yes',
		no: 'No',
		emptyTableColumn: '-',
		continue: 'Continue',
		previous: 'Previous',
		added: 'Added',

		dateFormat: {
			short: 'MM.DD.YYYY'
		},

		// navigation terms
		products: 'Products',
		watchlists: 'Watchlists',
		authenticateWithZoho: 'Authenticate with Zoho',

		// woodtypes
		product: 'Product',
		veneer: 'Veneer',
		pallet: 'Pallet',

		// search types
		searchTypes: {
			blockSearch: 'Logs',
			palletSearch: 'Pallets'
		},

		// product types
		veneerLog: 'Veneer log',

		// gallery
		speciesCount: '{count} Species',
		viewType: 'View',
		searchType: 'Layer',
		filter: 'Filter',

		// product card
		name: 'Name',
		species: 'Species',
		logNo: 'Log no.',
		logArea: 'Log',
		packageArea: 'Packages',
		inLogPercentage: 'in Log',
		measuredArea: 'measured',
		palletArea: 'Pal.',
		inPalletPercentage: 'in Pal.',
		resultArea: 'Filtered Quantity',
		quality: 'Quality',
		grade: 'Grade',
		place: 'Place',
		thickness: 'Thickness',
		maxLength: 'Main length',
		structure: 'Structure',
		characteristic: 'Characteristic',
		palletNo: 'Pallet no.',
		internalQuality: 'Internal quality',
		palletInfo: 'Pallet info',
		palletInfoInternal: 'Internal pallet info',
		logInfo: 'Log info',
		furtherInformation: 'Further information',
		logUnavailable: {
			short: 'Log not available',
			long: 'Unfortunately this log is no longer available.'
		},
		palletUnavailable: {
			short: 'Pallet not available',
			long: 'Unfortunately this pallet is no longer available.'
		},
		bundleCount: 'Bundles',
		previewImageUnavailable: 'Unfortunately the preview image is not available',

		// watchlist
		customer: 'Customer',
		contact: 'Contact',
		shared: 'Shared',
		currency: 'Currency',
		settingsTab: 'Settings',
		searchParamsTab: 'Search parameters',
		dynamic: 'Dynamic',
		static: 'Static',
		watchLog: 'Watch log',
		watchPallet: 'Watch pallet',

		// system text
		noResults: 'No results',
		noSearchParams: 'Please specify search parameters',
		addDescription: 'Add description...',
		addPrice: 'Add price...',
		more: 'more',
		less: 'less',
		confirmationText: {
			deleteWatchlist: 'Do you really want to delete this watchlist "{watchlistName}"?',
			deleteWatchlistItem: 'Would you like to remove this object from the watchlist?',
			removeLogFromVirtual: 'Do you want to remove this log? This will also remove all bundles and images associated with this log.',
		},
		watchlistUnavailable: 'This watchlist is not available.',

		// veneer search sorting
		sorting: 'Sort by',

		log: {
			selectedPreviewImage: 'Selected Teaser'
		},

		bundle: {
			packageNr: 'Package number',
			sheets: 'Number of sheets',
			length: 'Length',
			width: 'Width',
			area: 'Area',
			originalLog: 'Original log no.',
			originalBundleNo: 'Original bundle no.'
		},

		virtual: {
			title: 'Virtual log',
			bundleTab: 'Logs',
			imageTab: 'Pictures',
			infoTab: 'Data of the log',
			noBundles: 'No bundels available',
			virtualBlock: 'Virtual lock',
			removeLog: 'Remove log',
			addAllBundles: 'Add all bundles'
		},

		label: {
			search: 'Search',

			crdate: 'Creation date',

			// gallery
			color: 'Color',
			application: 'Application',
			occurrence: 'Occurrence',
			availability: 'Availability',
			pricegroup: 'Pricegroup',
			fsc: 'Only FSC® certified',
			pefc: 'Only PEFC certified',

			// searchbar
			from: 'from',
			to: 'to',
			thickness: 'Thickness in mm',
			characteristic: 'Characteristic',
			qualities: 'Qualities',
			structure: 'Structure',
			length: 'Length',
			width: 'Width',
			grade: 'Grade',
			internalQuality: 'Internal quality',
			logNo: 'Log no.',
			palletNo: 'Pallet no.',
			info: 'Info',

			// watchlist
			watchlist: 'Watchlist',
			watchlistName: 'Name',
			price: 'Price',
			comment: 'Comment',
			seller: 'Seller',
			type: 'Type',
			language: 'Language',
			itemCount: 'Logs',

			simplified: 'Simple watchlist view',
			showBundleImages: 'Show bundle pictures',
			shared: 'Shared',
			sharedUntil: 'Shared until',
			toggleAllLogImages: 'Select all',

			languages: {
				German: 'German',
				English: 'English'
			},

			productTypes: {
				0: 'Veneer'
			},
			watchlistType: 'Type'
		},

		unit: {
			mm: 'mm',
			cm: 'cm',
			m: 'm',
			sqm: 'm²',
			pricePerSqm: '€/m²',
			perSqm: '/m²',
			percentage: '%'
		},

		input: {
			//all: 'All',
			allColors: 'All colors',
			allApplications: 'All applications',
			allOccurrences: 'All occurrences'
		},

		// buttons
		button: {
			logout: 'Logout',
			back: 'Back',
			watch: 'Watch',
			save: 'Save',
			create: 'Create',
			remove: 'Remove',
			update: 'Update',
			delete: 'Delete',
			edit: 'Edit',
			cancel: 'Cancel',
			search: 'Search',
			preview: 'Preview',
			watchlistSettings: 'Watchlist settings',
			share: 'Release settings',
			newVirtualLog: 'Creating a virtual log',
			addToVirtualLog: 'Add to virtual log',
			addToWatchlist: 'Add to watchlist',
			addAllToWatchlist: 'Add all to watchlist',
			createWatchlist: 'Create watchlist',
			deleteWatchlist: 'Delete watchlist',
			editSearchParams: 'Edit search parameters',
			copyWatchlistLink: 'Release link',
			copyNeutralWatchlistLink: 'Neutral link',
			newWatchlistAddFromWatchlist: 'Add logs via watchlists',
			newWatchlistAddFromSearch: 'Add logs via product search',
			newWatchlistSearchParametersFromSearch: 'Add parameter via product search',
			newWatchlistSearchParametersFromWatchlist: 'Add parameter via watchlist',
			addLogsToVirtualFromSearch: 'Add logs via product search',
			addLogsToVirtualFromWatchlist: 'Add logs via watchlists',
			download: 'Download',
			gallery: 'Gallery',
			list: 'List',
			listtype: {
				1: 'Name',
				name: 'Name',
				2: 'Trade name',
				tradename: 'Trade name',
				3: 'Botanical name',
				botanicalname: 'Botanical name'
			},
			measurementList: 'Measurement list',
			downloadImages: 'Download images',
			confirmSettings: 'Confirm settings',
			downloadWatchlistSummary: 'Download watchlist',
			previousLog: 'Previous log',
			nextLog: 'Next log',
			logSearchSorting: {
				0: 'Log no.',
				1: 'Pallet no.',
				2: 'Internal quality',
				3: 'Quality',
			},
			watchlistSorting: {
				added: 'Added',
				logArea: 'Quantity',
				customerQualityName: 'Quality',
				logNo: 'Log no.',
				palletNo: 'Pallet no.'
			},
			minimize: 'Minimize',
			palletLogs: 'Log list',
			addAllPalletLogsToWatchlist: 'Add all logs to a watchlist',
			detailView: 'Details'
		},

		addToWatchlist: {
			step: {
				1: 'Select watchlist',
				2: 'Edit log data',
				3: 'Select images'
			}
		},
		activeWatchlistsTableTitle: 'Already on following watchlists',
		checkingActiveWatchlists: 'Checking active watchlists',

		tooltip: {
			remove: 'Remove',
			asPreviewImage: 'Use as preview image',
			resetPreviewImage: 'Restore original thumbnail',
			setWatchlistItemLogImages: 'Hand pictures',
			createWatchlistFromSearchParams: 'Create dynamic watchlist from current search.',
			resetSearchParams: 'Reset search'
		},

		// snackbar messages
		snack: {
			// generic request error
			requestError: 'Error during data transmission.',
			// system errors
			noLogin: 'You were automatically logged out due to inactivity.',
			// confirmations
			addedToWatchlist: 'Object was added to the watchlist.',
			alreadyOnWatchlist: 'Object is already on this watchlist.',
			alreadyOnVirtualLogInWatchlist: 'Object is already in a virtual log on this watchlist.',
			addedToVirtualLogOnWatchlist: 'Object was added to a virtual log on this watchlist.',
			createdAndAddedToVirtualLogOnWatchlist: 'Created virtual log on this watchlist and added Object.',
			matchingLogOnWatchlist: 'Found matching log on watchlist. This Object will be added to a virtual log.',
			zohoAuthenticationError: 'Error with Zoho Authentication, please check you login status.',
			createdWatchlist: 'New watchlist was successfully created.',
			deletedWatchlist: 'Watchlist has been deleted',
			updatedWatchlist: 'Settings have been successfully updated',
			updatedWatchlistItem: 'Settings have been successfully updated',
			watchlistLinkSuccessfullyCopied: 'The release link has been copied to the clipboard.',
			watchlistLinkCopyError: 'The release link could not be copied.',
			updatedVirtualLog: 'Virtual log updated.',
			addedToVirtualLog: 'Added to virtual log.',
			alreadyOnVirtualLog: 'Log already added.'
		},

		error: {
			customer: 'Please select a customer.',
			logProps: {
				species: 'Please select a wood species.',
				name: 'Please enter a log number.'
			},
			watchlistProps: {
				name: 'Please enter a name for this watchlist.'
			}
		},

		mask: {
			currency: '#.##'
		},

		languageSwitcher: {
			german: 'Deutsch',
			english: 'English',
			simple: {
				german: 'DE',
				english: 'EN'
			}
		}
	}
}